const marathiMatrimony = {
  id: 3,
  slug: "marathi-matrimony",

  title: "Marathi Matrimony",

  description:
    "A modern matrimonial platform built for the Marathi community, offering secure profile verification, intelligent partner recommendations, real-time messaging, and premium membership features.",

  category: "Matrimony",
  type: "Client Project",
  status: "Completed",
  year: "2026",

  timeline: "5 Months",

  developedBy: "Horyzen Technologies",

  role: "Full Stack Mobile Development",

  technologies: [
    "Flutter",
    "Firebase",
    "Cloud Firestore",
    "Firebase Authentication",
    "Firebase Cloud Messaging",
    "Node.js",
    "Express.js"
  ],

  image: "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&w=1600&q=80",

  liveUrl: "",
  githubUrl: "",

  featured: true
};

export default marathiMatrimony;